import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.user.DOC}
  query UsersInScenario(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $ids: [ID!]
    $quantity: Int
    $cursor: String
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            users(ids: $ids, quantity: $quantity, cursor: $cursor) {
              items {
                info {
                  ...FragmentUser
                }
                scenarioAccess
              }
              nextCursor
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.UsersInScenarioQuery,
    ents.core.common.Response.For.Pagination<models.User>,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'users',
            graphql.transformers.OUT.object({
              items: graphql.transformers.OUT.default(
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.custom(user => {
                    TypeAsserter.assertIsNotNullish(user?.info)
                    return {
                      ...fragments.user.TRANSFORMER.getEntityFrom(user.info),
                      // TODO: remove id and name transforming when figure out
                      // how to handle error that happens when those properties
                      // are not handled here
                      id: user.info.id ?? undefined,
                      name:
                        user.info.firstName && user.info.lastName
                          ? `${user.info.firstName} ${user.info.lastName}`
                          : (user.info.firstName ??
                            user.info.lastName ??
                            'Unknown User'),
                      scenarioAccess: user?.scenarioAccess ?? undefined,
                    }
                  }),
                  { onNullish: 'remove' },
                ),
                [],
              ),
              nextCursor: () => undefined,
            }),
          ),
        ),
      ),
    ),
  ),
  { items: [], nextCursor: undefined },
)

export const execute = graphql.createExecutor<
  graphql.schema.UsersInScenarioQuery,
  ents.core.common.Response.For.Pagination<models.User>,
  graphql.schema.UsersInScenarioQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
